import React, { useEffect } from "react";
import { Link, } from "react-router-dom";
import { useSideBar } from "../context/SideBarContext";
import { useTour } from "../context/TourContext";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { PORTAL_LOGO_MINI } from "../../Util/constant";
const Navbar = () => {
	const { toggleSideBar } = useSideBar();
	const { startTourForPage } = useTour();
	const location = useLocation();

	const toggleOffcanvas = () => {
		document.querySelector(".sidebar-offcanvas").classList.toggle("active");
	};

	// On mobile, close the off-canvas sidebar when clicking/tapping outside it
	useEffect(() => {
		const handleOutsideClick = (e) => {
			if (window.innerWidth >= 992) return;
			const sidebar = document.querySelector(".sidebar-offcanvas");
			if (!sidebar?.classList.contains("active")) return;
			if (sidebar.contains(e.target) || e.target.closest(".navbar-toggler-right")) return;
			sidebar.classList.remove("active");
		};
		document.addEventListener("mousedown", handleOutsideClick);
		document.addEventListener("touchstart", handleOutsideClick);
		return () => {
			document.removeEventListener("mousedown", handleOutsideClick);
			document.removeEventListener("touchstart", handleOutsideClick);
		};
	}, []);

	// On mobile the off-canvas sidebar overlaps the tour, so close it before starting
	const handleStartTour = () => {
		if (window.innerWidth < 992) {
			document.querySelector(".sidebar-offcanvas")?.classList.remove("active");
		}
		startTourForPage(currentKey);
	};

	const getCleanPathKey = (path) => {
		const segments = path.split("/").filter(Boolean);
		return segments
			.map((segment) =>
				/^\d+$/.test(segment) || /^[0-9a-fA-F\-]{4,}$/.test(segment)
					? "info"
					: segment
			)
			.join("_") || "dashboard";
	};

	const currentKey = getCleanPathKey(location.pathname);

	const hiddenTourPaths = ["/dashboard", "/profile", '/configs'];
	const shouldHideTourButton = hiddenTourPaths.includes(location.pathname);

	return (
		<>
			<nav className="navbar p-0 fixed-top d-flex flex-row">
				<div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
					<div className="navbar-brand brand-logo-mini">
						<img src={PORTAL_LOGO_MINI} alt="logo" />


					</div>
				</div>
				<div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch justify-content-end">
					<button
						className="navbar-toggler navbar-toggler align-self-center"
						type="button"
						style={{ border: 'none', boxShadow: 'none', outline: 'none', background: 'transparent' }}

						onClick={() => {
							document.body.classList.toggle("sidebar-icon-only");
							toggleSideBar();
						}}
					>
						<span className="mdi mdi-menu"></span>
					</button>

					<ul className="navbar-nav navbar-nav-right">
						{!shouldHideTourButton && (
							<Button
								variant="" className="info-button"
								onClick={handleStartTour}
							>
								Start Tour
							</Button>
						)}

					</ul>
					<button
						className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
						type="button"
						onClick={toggleOffcanvas}
						style={{ border: 'none', boxShadow: 'none', outline: 'none', background: 'transparent' }}
					>
						<span className="mdi mdi-format-line-spacing"></span>
					</button>
				</div>
			</nav>
		</>
	);
};

export default Navbar;